<template>
  <a :href="url" target="_blank" class="icon is-large">
    <fa :icon="['fab', 'linkedin']" size="2x" />
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      message: 'socialMessage',
    }),
    path() {
      return window.location.href;
    },
    url() {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.path}&title=&summary=${this.message}&source=`;
    }
  },
};
</script>
